// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { FaApple, FaEdit, FaPlus, FaTrash } from "react-icons/fa";
// import "./SoftwareDownloads.css";
// import axios from 'axios';
// import { Base_Url } from '../config';
// import JoditEditor from 'jodit-react';
// import { useSelector } from 'react-redux';
// import { FcDocument } from "react-icons/fc";

// const PLATFORM_ICONS = {
//   Windows: '🪟',
//   Linux: '🐧',
//   Mac: <FaApple size={18} className='mb-1' />,
//   Documentation: <FcDocument size={20} className='mb-1' />,
// };

// const DownloadTable = ({ data, onEdit, onDelete }) => {
//   if (!data || data.length === 0) return <p>No data available.</p>;

//   return (
//     <div className="custom-table-container">
//       <table className="table custom-table">
//         <thead>
//           <tr>
//             <th className="text-center">Version</th>
//             <th className="text-center">Platform</th>
//             <th>Download Link</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((version, versionIndex) => (
//             <React.Fragment key={version.VersionId}>
//               {version.Platforms.map((platform, platformIndex) => (
//                 <tr key={platformIndex} className={versionIndex % 2 === 0 ? 'even-row' : 'odd-row'}>
//                   {platformIndex === 0 && (
//                     <td className="version-cell text-center" rowSpan={version.Platforms.length}>
//                       <span className="version-badge">{version.VersionName}</span>
//                     </td>
//                   )}
//                   <td className="platform-cell text-center">
//                     <div className={`platform-badge ${platform.Platform?.toLowerCase() || ''}`}>
//                       <span className="platform-icon">
//                         {platform.Platform === 'Windows' ? PLATFORM_ICONS.Windows :
//                           platform.Platform === 'Linux' ? PLATFORM_ICONS.Linux : 
//                           platform.Platform === 'Documentation' ? PLATFORM_ICONS.Documentation : 
//                             platform.Platform === 'Mac' ? PLATFORM_ICONS.Mac : ''}
//                       </span>
//                       <span className="platform-text">{platform.Platform}</span>
//                     </div>
//                   </td>
//                   <td className="download-cell text-center">
//                     <div className="d-flex flex-column">
//                       {platform.DownloadLinks.map((link, linkIdx) => (
//                         <a key={linkIdx} href={link.link} className="download-link mb-2">
//                           <span className="disk-label">{link.name}</span>
//                         </a>
//                       ))}
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </React.Fragment>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// const SoftwareDownloads = () => {
//   const navigate = useNavigate();
//   const [activeAccordion, setActiveAccordion] = useState(null);
//   const [softwareData, setSoftwareData] = useState([]);
//   const [editingContent, setEditingContent] = useState(null);
//   const [editorContent, setEditorContent] = useState('');

//   const fetchData = async () => {
//     try {
//       const [softwareRes, versionRes, platformRes, diskRes, sciSoftPageRes] = await Promise.all([
//         axios.get(`${Base_Url}/software`),
//         axios.get(`${Base_Url}/version`),
//         axios.get(`${Base_Url}/platform`),
//         axios.get(`${Base_Url}/disk`),
//         axios.get(`${Base_Url}/scisoftpages`)
//       ]);
  
//       const structuredData = softwareRes.data.map(software => {
//         const versions = versionRes.data.filter(v => v.software_id === software.id);
  
//         // Sort versions in descending order based on year
//         const sortedVersions = versions.sort((a, b) => {
//           // Extract year and optional letter (like '2024a' -> ['2024', 'a'])
//           const aMatch = a.version_name.match(/^(\d+)([a-z]?)$/i);
//           const bMatch = b.version_name.match(/^(\d+)([a-z]?)$/i);
          
//           const aYear = aMatch ? parseInt(aMatch[1]) : 0;
//           const bYear = bMatch ? parseInt(bMatch[1]) : 0;
          
//           // First compare by year
//           if (bYear !== aYear) {
//             return bYear - aYear;
//           }
          
//           // If years are equal, compare by optional letter
//           const aLetter = aMatch && aMatch[2] ? aMatch[2].toLowerCase() : '';
//           const bLetter = bMatch && bMatch[2] ? bMatch[2].toLowerCase() : '';
          
//           return bLetter.localeCompare(aLetter);
//         });
  
//         const versionData = sortedVersions.map(version => {
//           const platforms = platformRes.data.filter(p => p.version_id === version.id);
  
//           const platformData = platforms.map(platform => {
//             const disks = diskRes.data.filter(d => d.platform_id === platform.id);
  
//             return {
//               Platform: platform.platform_name,
//               DownloadLinks: disks.map(disk => ({
//                 name: `${disk.disk_size}`,
//                 link: disk.download_link
//               }))
//             };
//           });
  
//           return {
//             VersionName: version.version_name,
//             VersionId: version.id,
//             Platforms: platformData
//           };
//         });
  
//         const setupGuide = sciSoftPageRes.data.find(page => page.software_id === software.id);
  
//         return {
//           ID: software.id,
//           MainHeading: software.name,
//           Versions: versionData,
//           SetupGuide: setupGuide ? setupGuide.content : 'No setup guide available.',
//           SetupGuideId: setupGuide ? setupGuide.id : null
//         };
//       });
  
//       setSoftwareData(structuredData);
//     } catch (error) {
//       console.error("Error fetching data", error);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const handleEditVersion = (versionId) => {
//     navigate(`/editscientific/${versionId}`);
//   };

//   const handleEditSetupGuide = (content, id) => {
//     setEditingContent(id);
//     setEditorContent(content);
//   };

//   const userfromwebmaster = useSelector((state) => state.user);
//   const statecsc = useSelector((state) => state.statecsc);

//   const handleSave = async (softwareId, setupGuideId) => {
//     try {
//       if (setupGuideId) {
//         await axios.put(`${Base_Url}/scisoftpages/${setupGuideId}`, {
//           id: setupGuideId,
//           software_id: softwareId,
//           content: editorContent
//         });
//       } else {
//         await axios.post(`${Base_Url}/scisoftpages`, {
//           software_id: softwareId,
//           content: editorContent
//         });
//       }
//       setEditingContent(null);
//       fetchData();
//     } catch (error) {
//       console.error("Error saving setup guide", error);
//     }
//   };

//   const handleDeleteSoftware = async (softwareId) => {
//     try {
//       await axios.delete(`${Base_Url}/software/${softwareId}`);
//       fetchData();
//     } catch (error) {
//       console.error("Error deleting software", error);
//     }
//   };

//   const handleDeleteSetupGuide = async (setupGuideId) => {
//     try {
//       await axios.delete(`${Base_Url}/scisoftpages/${setupGuideId}`);
//       fetchData();
//     } catch (error) {
//       console.error("Error deleting setup guide", error);
//     }
//   };

//   return (
//     <div className="container py-4">

//       {/* Contact Email Section - Enhanced */}

//       {/* Warning Alert */}
//       <div className="alert alert-danger mb-4 m-0" role="alert">
//         <h4 className="alert-heading">WARNING! DO NOT DOWNLOAD WHILE YOUR PROXY CONNECTION IS ACTIVE!</h4>
//         <p className="mb-0">This is an internal site and all files can be downloaded without logging in to the proxy server</p>
//       </div>

//       {/* Additional Information Section */}
//       <div className="alert alert-info mb-4" role="alert">
//         <h4 className="alert-heading">Explore Beyond Basics</h4>
//         <p>
//           Here you can find information for all the software that is licensed for use by the IITD community.
//           We provide basic support in installation of these software. However, for detailed/technical support,
//           the respective vendors/software support teams need to be contacted.
//         </p>
//       </div>
//       {/* <div className="alert alert-warning mb-4" role="alert">
//         <h4 className="alert-heading">Research software pre-requisites</h4>
//         <p className='mb-1'> In case the software is not listed here, the same can be requested from CSC.
//         </p>
//         <p> Minimum of 3 academic units and a minimum of 5 faculty members need to recommend the software, along with number of licenses required.
//         </p>
//       </div> */}
//    <div className="alert alert-warning mb-4" role="alert">
//         <h4 className="alert-heading">Software pre-requisites</h4>
//         <p className='mb-1'> 1. If a software is needed for research purposes, then kindly send a note to Head CSC. There should at least be 5 active users (faculty) of the software across 3 academic units. 
//         </p>
//         <p className='mb-0'>2. If a software is needed for teaching, then kindly route the request via the respective DFB. 
//         </p>
//         <p>3. Some of our tool licenses are expected to expire shortly. Requesting the relevant AUs to kindly let us know about the future requirements.
//         </p>
//       </div>

//       <div className="contact-email-section mb-4 p-4 rounded-3" style={{
//  background: 'linear-gradient(135deg, #faf9f9f1 0%, #ecececff 100%)',
//   border: 'none',
//   boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
// }}>
//   <div className="row align-items-center">
//     <div className="col-md-8">
//       <h4 className=" mb-2 fw-bold" style={{color:"#666464"}}>
//         <i className="fas fa-envelope me-2"></i>
//         Contact Us
//       </h4>
//     </div>
//     <div className="col-md-4 text-md-end">
//       <div className="d-inline-block bg-white px-3 py-2 rounded-2">
//         <strong className="text-dark me-2">Email:</strong>
//         <a 
//           href="mailto:scisoft@cc.iitd.ac.in" 
//           className="fw-bold text-decoration-none"
//           style={{ color: '#764ba2' }}
//           onMouseOver={(e) => e.target.style.color = '#667eea'}
//           onMouseOut={(e) => e.target.style.color = '#764ba2'}
//         >
//           scisoft@cc.iitd.ac.in
//         </a>
//       </div>
//     </div>
//   </div>
// </div>
//       {(userfromwebmaster.userExists || statecsc.userState === 0) && (
//         <div className="ms-auto">
//           <button
//             className="btn btn-primary btn-sm me-2"
//             onClick={() => navigate("/add-scisoft")}
//           >
//             <FaPlus /> Add
//           </button>
//         </div>
//       )}

//       {/* Software Accordion */}
//       <div className="accordion" id="softwareAccordion">
//         {softwareData.map((item, index) => (
//           <div className="accordion-item mb-1"   key={index}>
//             <h2 className="accordion-header">
//               <button
//               style={{background:"#a32424"}}
//                 className={`accordion-button sciaccordion ${activeAccordion !== item.ID ? 'collapsed' : ''}`}
//                 type="button"
//                 onClick={() => setActiveAccordion(activeAccordion !== item.ID ? item.ID : '')}
//               >
//                 {item.MainHeading}

//                 {(userfromwebmaster.userExists || statecsc.userState === 0) && (
//                   <div className="ms-auto">
//                     <button
//                       className="btn btn-primary btn-sm me-2"
//                       onClick={() => handleEditVersion(item.ID)}
//                     >
//                       <FaEdit /> Edit
//                     </button>
//                     <button
//                       className="btn btn-danger btn-sm"
//                       onClick={() => handleDeleteSoftware(item.ID)}
//                     >
//                       <FaTrash /> Delete
//                     </button>
//                   </div>
//                 )}
//               </button>
//             </h2>
//             <div
//               className={`accordion-collapse collapse ${activeAccordion === item.ID ? 'show' : ''}`}
//             >
//               <div className="accordion-body">
//                 <div className="row">
//                   <div className="col-lg-7">
//                     <DownloadTable
//                       data={item.Versions}
//                       onEdit={handleEditVersion}
//                       onDelete={handleDeleteSetupGuide}
//                     />
//                   </div>
//                   <div className="col-lg-5">
//                     <div className="setup-guide-container">
//                       <h5>Setup Guide</h5>
//                       {editingContent === item.ID ? (
//                         <>
//                           <JoditEditor
//                             value={editorContent}
//                             onChange={newContent => setEditorContent(newContent)}
//                           />
//                           <button
//                             className="btn btn-success btn-sm mt-2"
//                             onClick={() => handleSave(item.ID, item.SetupGuideId)}
//                           >
//                             Save
//                           </button>
//                           <button
//                             className="btn btn-secondary btn-sm mt-2 ms-2"
//                             onClick={() => setEditingContent(null)}
//                           >
//                             Cancel
//                           </button>
//                         </>
//                       ) : (
//                         <>
//                           <div dangerouslySetInnerHTML={{ __html: item.SetupGuide }} />
//                         </>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default SoftwareDownloads;

// SoftwareDownloads.js - Optimized Version
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaApple, FaEdit, FaPlus, FaTrash, FaTimes, FaSave } from "react-icons/fa";
import { FcDocument } from "react-icons/fc";
import "./SoftwareDownloads.css";
import axios from 'axios';
import { Base_Url } from '../config';
import JoditEditor from 'jodit-react';
import { useSelector } from 'react-redux';

const PLATFORM_ICONS = {
  Windows: '🪟',
  Linux: '🐧',
  Mac: <FaApple size={18} className='mb-1' />,
  Documentation: <FcDocument size={20} className='mb-1' />,
};

// DownloadTable Component
const DownloadTable = ({ data, onEdit, onDelete, canEdit }) => {
  if (!data || data.length === 0) return <p>No data available.</p>;

  return (
    <div className="custom-table-container">
      <table className="table custom-table">
        <thead>
          <tr>
            <th className="text-center">Version</th>
            <th className="text-center">Platform</th>
            <th>Download Link</th>
            {canEdit && <th className="text-center">Actions</th>}
          </tr>
        </thead>
        <tbody>
          {data.map((version, versionIndex) => (
            <React.Fragment key={version.VersionId}>
              {version.Platforms.map((platform, platformIndex) => (
                <tr key={platformIndex} className={versionIndex % 2 === 0 ? 'even-row' : 'odd-row'}>
                  {platformIndex === 0 && (
                    <td className="version-cell text-center" rowSpan={version.Platforms.length}>
                      <span className="version-badge">{version.VersionName}</span>
                    </td>
                  )}
                  <td className="platform-cell text-center">
                    <div className={`platform-badge ${platform.Platform?.toLowerCase() || ''}`}>
                      <span className="platform-icon">
                        {platform.Platform === 'Windows' ? PLATFORM_ICONS.Windows :
                          platform.Platform === 'Linux' ? PLATFORM_ICONS.Linux : 
                          platform.Platform === 'Documentation' ? PLATFORM_ICONS.Documentation : 
                            platform.Platform === 'Mac' ? PLATFORM_ICONS.Mac : ''}
                      </span>
                      <span className="platform-text">{platform.Platform}</span>
                    </div>
                  </td>
                  <td className="download-cell text-center">
                    <div className="d-flex flex-column">
                      {platform.DownloadLinks.map((link, linkIdx) => (
                        <a key={linkIdx} href={link.link} className="download-link mb-2">
                          <span className="disk-label">{link.name}</span>
                        </a>
                      ))}
                    </div>
                  </td>
                  {canEdit && platformIndex === 0 && (
                    <td className="text-center" rowSpan={version.Platforms.length}>
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => onEdit(version.VersionId)}
                        title="Edit Version"
                      >
                        <FaEdit />
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// AlertManager Component
const AlertManager = ({ alertType, alertData, onUpdate, canEdit }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editContent, setEditContent] = useState('');
    const [editTitle, setEditTitle] = useState('');
    const [alertId, setAlertId] = useState(null);
    const editor = useRef(null);

    const editorConfig = {
        readonly: false,
        height: 200,
        toolbar: true,
        buttons: ['bold', 'italic', 'underline', '|', 'ul', 'ol', '|', 'font', 'fontsize', '|', 'link', '|', 'align', 'undo', 'redo'],
        placeholder: 'Enter alert content...'
    };

    const getAlertStyles = () => {
        switch(alertType) {
            case 'alerts1':
                return {
                    bgClass: 'alert-danger',
                    defaultTitle: 'WARNING! DO NOT DOWNLOAD WHILE YOUR PROXY CONNECTION IS ACTIVE!',
                    defaultContent: '<p class="mb-0">This is an internal site and all files can be downloaded without logging in to the proxy server</p>'
                };
            case 'alerts2':
                return {
                    bgClass: 'alert-info',
                    defaultTitle: 'Explore Beyond Basics',
                    defaultContent: '<p>Here you can find information for all the software that is licensed for use by the IITD community. We provide basic support in installation of these software. However, for detailed/technical support, the respective vendors/software support teams need to be contacted.</p>'
                };
            case 'alerts3':
                return {
                    bgClass: 'alert-warning',
                    defaultTitle: 'Software pre-requisites',
                    defaultContent: '<p class="mb-1">1. If a software is needed for research purposes, then kindly send a note to Head CSC. There should at least be 5 active users (faculty) of the software across 3 academic units.</p><p class="mb-0">2. If a software is needed for teaching, then kindly route the request via the respective DFB.</p><p>3. Some of our tool licenses are expected to expire shortly. Requesting the relevant AUs to kindly let us know about the future requirements.</p>'
                };
            default:
                return {
                    bgClass: 'alert-secondary',
                    defaultTitle: 'Alert',
                    defaultContent: '<p>Alert content</p>'
                };
        }
    };

    const styles = getAlertStyles();

    useEffect(() => {
        if (alertData) {
            setEditTitle(alertData.title || '');
            setEditContent(alertData.content || '');
            setAlertId(alertData.id || null);
        } else {
            setEditTitle(styles.defaultTitle);
            setEditContent(styles.defaultContent);
            setAlertId(null);
        }
    }, [alertData]);

    const handleSave = async () => {
        try {
            const payload = {
                title: editTitle,
                content: editContent
            };

            let response;
            if (alertId) {
                response = await axios.put(`${Base_Url}/${alertType}/${alertId}`, payload);
            } else {
                response = await axios.post(`${Base_Url}/${alertType}`, payload);
            }

            if (response.status === 200 || response.status === 201) {
                setIsEditing(false);
                onUpdate();
            }
        } catch (error) {
            console.error(`Error saving ${alertType}:`, error);
            alert('Error saving alert. Please try again.');
        }
    };

    const handleDelete = async () => {
        if (!alertId) return;
        
        if (window.confirm('Are you sure you want to delete this alert?')) {
            try {
                await axios.delete(`${Base_Url}/${alertType}/${alertId}`);
                onUpdate();
            } catch (error) {
                console.error(`Error deleting ${alertType}:`, error);
                alert('Error deleting alert. Please try again.');
            }
        }
    };

    if (!isEditing) {
        return (
            <div className={`alert ${styles.bgClass} mb-4 position-relative`} role="alert" 
                 style={{ paddingRight: canEdit ? '100px' : '1rem' }}>
                
                {canEdit && (
                    <div className="position-absolute top-0 end-0 mt-2 me-2" style={{ zIndex: 5 }}>
                        {!alertData ? (
                            <button
                                className="btn btn-sm btn-outline-dark"
                                onClick={() => setIsEditing(true)}
                                title="Add Alert"
                                style={{ backgroundColor: 'rgba(255,255,255,0.9)' }}
                            >
                                <FaPlus /> Add
                            </button>
                        ) : (
                            <>
                                <button
                                    className="btn btn-sm btn-outline-primary me-1"
                                    onClick={() => setIsEditing(true)}
                                    title="Edit Alert"
                                    style={{ backgroundColor: 'rgba(255,255,255,0.9)' }}
                                >
                                    <FaEdit />
                                </button>
                                <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={handleDelete}
                                    title="Delete Alert"
                                    style={{ backgroundColor: 'rgba(255,255,255,0.9)' }}
                                >
                                    <FaTimes />
                                </button>
                            </>
                        )}
                    </div>
                )}
                
                <h4 className="alert-heading">{alertData ? alertData.title : styles.defaultTitle}</h4>
                {alertData ? (
                    <div dangerouslySetInnerHTML={{ __html: alertData.content }} />
                ) : (
                    <div dangerouslySetInnerHTML={{ __html: styles.defaultContent }} />
                )}
            </div>
        );
    }

    return (
        <div className={`alert ${styles.bgClass} mb-4`} role="alert">
            <div className="mb-3">
                <label className="form-label fw-bold">Alert Title</label>
                <input
                    type="text"
                    className="form-control"
                    value={editTitle}
                    onChange={(e) => setEditTitle(e.target.value)}
                    placeholder="Enter alert title..."
                />
            </div>
            
            <div className="mb-3">
                <label className="form-label fw-bold">Alert Content</label>
                <JoditEditor
                    ref={editor}
                    value={editContent}
                    config={editorConfig}
                    tabIndex={1}
                    onBlur={(newContent) => setEditContent(newContent)}
                />
            </div>

            <div className="d-flex gap-2 justify-content-end">
                <button
                    className="btn btn-success btn-sm"
                    onClick={handleSave}
                >
                    <FaSave /> Save
                </button>
                <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => setIsEditing(false)}
                >
                    <FaTimes /> Cancel
                </button>
            </div>
        </div>
    );
};

// Main SoftwareDownloads Component
const SoftwareDownloads = () => {
  const navigate = useNavigate();
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [softwareData, setSoftwareData] = useState([]);
  const [editingContent, setEditingContent] = useState(null);
  const [editorContent, setEditorContent] = useState('');
  const [alerts, setAlerts] = useState({ alerts1: null, alerts2: null, alerts3: null });
  const [loading, setLoading] = useState(true);

  // Get user state from Redux - DIRECT CHECK
  const userfromwebmaster = useSelector((state) => state.user);
  const statecsc = useSelector((state) => state.statecsc);
  
  // DIRECT canEdit check - agar true hai toh buttons dikhao
  const canEdit = (userfromwebmaster && userfromwebmaster.userExists === true) || 
                  (statecsc && statecsc.userState === 0);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [softwareRes, versionRes, platformRes, diskRes, sciSoftPageRes, alerts1Res, alerts2Res, alerts3Res] = await Promise.all([
        axios.get(`${Base_Url}/software`),
        axios.get(`${Base_Url}/version`),
        axios.get(`${Base_Url}/platform`),
        axios.get(`${Base_Url}/disk`),
        axios.get(`${Base_Url}/scisoftpages`),
        axios.get(`${Base_Url}/alerts1`),
        axios.get(`${Base_Url}/alerts2`),
        axios.get(`${Base_Url}/alerts3`)
      ]);
  
      const structuredData = softwareRes.data.map(software => {
        const versions = versionRes.data.filter(v => v.software_id === software.id);
  
        const sortedVersions = versions.sort((a, b) => {
          const aMatch = a.version_name.match(/^(\d+)([a-z]?)$/i);
          const bMatch = b.version_name.match(/^(\d+)([a-z]?)$/i);
          
          const aYear = aMatch ? parseInt(aMatch[1]) : 0;
          const bYear = bMatch ? parseInt(bMatch[1]) : 0;
          
          if (bYear !== aYear) {
            return bYear - aYear;
          }
          
          const aLetter = aMatch && aMatch[2] ? aMatch[2].toLowerCase() : '';
          const bLetter = bMatch && bMatch[2] ? bMatch[2].toLowerCase() : '';
          
          return bLetter.localeCompare(aLetter);
        });
  
        const versionData = sortedVersions.map(version => {
          const platforms = platformRes.data.filter(p => p.version_id === version.id);
  
          const platformData = platforms.map(platform => {
            const disks = diskRes.data.filter(d => d.platform_id === platform.id);
  
            return {
              Platform: platform.platform_name,
              DownloadLinks: disks.map(disk => ({
                name: `${disk.disk_size}`,
                link: disk.download_link
              }))
            };
          });
  
          return {
            VersionName: version.version_name,
            VersionId: version.id,
            Platforms: platformData
          };
        });
  
        const setupGuide = sciSoftPageRes.data.find(page => page.software_id === software.id);
  
        return {
          ID: software.id,
          MainHeading: software.name,
          Versions: versionData,
          SetupGuide: setupGuide ? setupGuide.content : 'No setup guide available.',
          SetupGuideId: setupGuide ? setupGuide.id : null
        };
      });
  
      setSoftwareData(structuredData);
      
      const normalizeAlert = (res) => {
        if (!res) return null;
        const data = res.data;
        if (Array.isArray(data)) return data.length ? data[0] : null;
        return data || null;
      };

      setAlerts({
        alerts1: normalizeAlert(alerts1Res),
        alerts2: normalizeAlert(alerts2Res),
        alerts3: normalizeAlert(alerts3Res)
      });
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  const refreshAlerts = async () => {
    try {
      const [alerts1Res, alerts2Res, alerts3Res] = await Promise.all([
        axios.get(`${Base_Url}/alerts1`),
        axios.get(`${Base_Url}/alerts2`),
        axios.get(`${Base_Url}/alerts3`)
      ]);

      const normalizeAlert = (res) => {
        if (!res) return null;
        const data = res.data;
        if (Array.isArray(data)) return data.length ? data[0] : null;
        return data || null;
      };

      setAlerts({
        alerts1: normalizeAlert(alerts1Res),
        alerts2: normalizeAlert(alerts2Res),
        alerts3: normalizeAlert(alerts3Res)
      });
    } catch (error) {
      console.error("Error refreshing alerts:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []); // Sirf initial load ke liye

  const handleEditVersion = (versionId) => {
    navigate(`/editscientific/${versionId}`);
  };

  const handleEditSetupGuide = (content, id) => {
    setEditingContent(id);
    setEditorContent(content);
  };

  const handleSave = async (softwareId, setupGuideId) => {
    try {
      if (setupGuideId) {
        await axios.put(`${Base_Url}/scisoftpages/${setupGuideId}`, {
          id: setupGuideId,
          software_id: softwareId,
          content: editorContent
        });
      } else {
        await axios.post(`${Base_Url}/scisoftpages`, {
          software_id: softwareId,
          content: editorContent
        });
      }
      setEditingContent(null);
      fetchData();
    } catch (error) {
      console.error("Error saving setup guide", error);
      alert('Error saving setup guide. Please try again.');
    }
  };

  const handleDeleteSoftware = async (softwareId) => {
    if (window.confirm('Are you sure you want to delete this software?')) {
      try {
        await axios.delete(`${Base_Url}/software/${softwareId}`);
        fetchData();
      } catch (error) {
        console.error("Error deleting software", error);
        alert('Error deleting software. Please try again.');
      }
    }
  };

  const handleDeleteSetupGuide = async (setupGuideId) => {
    if (window.confirm('Are you sure you want to delete this setup guide?')) {
      try {
        await axios.delete(`${Base_Url}/scisoftpages/${setupGuideId}`);
        fetchData();
      } catch (error) {
        console.error("Error deleting setup guide", error);
        alert('Error deleting setup guide. Please try again.');
      }
    }
  };

  if (loading) {
    return (
      <div className="container py-4 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      
      {/* DYNAMIC ALERTS - canEdit prop pass karo */}
      <AlertManager 
        alertType="alerts1"
        alertData={alerts.alerts1}
        onUpdate={refreshAlerts}
        canEdit={canEdit}
      />

      <AlertManager 
        alertType="alerts2"
        alertData={alerts.alerts2}
        onUpdate={refreshAlerts}
        canEdit={canEdit}
      />

      <AlertManager 
        alertType="alerts3"
        alertData={alerts.alerts3}
        onUpdate={refreshAlerts}
        canEdit={canEdit}
      />

      {/* Contact Email Section */}
      <div className="contact-email-section mb-4 p-4 rounded-3" style={{
        background: 'linear-gradient(135deg, #faf9f9f1 0%, #ecececff 100%)',
        border: 'none',
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
      }}>
        <div className="row align-items-center">
          <div className="col-md-8">
            <h4 className="mb-2 fw-bold" style={{color:"#666464"}}>
              <i className="fas fa-envelope me-2"></i>
              Contact Us
            </h4>
          </div>
          <div className="col-md-4 text-md-end">
            <div className="d-inline-block bg-white px-3 py-2 rounded-2">
              <strong className="text-dark me-2">Email:</strong>
              <a 
                href="mailto:scisoft@cc.iitd.ac.in" 
                className="fw-bold text-decoration-none"
                style={{ color: '#764ba2' }}
              >
                scisoft@cc.iitd.ac.in
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Add Software Button - DIRECT canEdit check */}
      {canEdit && (
        <div className="d-flex justify-content-end mb-3">
          <button
            className="btn btn-primary"
            onClick={() => navigate("/add-scisoft")}
          >
            <FaPlus /> Add New Software
          </button>
        </div>
      )}

      {/* Software Accordion */}
      <div className="accordion" id="softwareAccordion">
        {softwareData.length === 0 ? (
          <div className="alert alert-info text-center">
            No software available.
          </div>
        ) : (
          softwareData.map((item, index) => (
            <div className="accordion-item mb-1" key={item.ID || index}>
              <h2 className="accordion-header">
                <button
                  style={{background:"#a32424", color: 'white'}}
                  className={`accordion-button sciaccordion ${activeAccordion !== item.ID ? 'collapsed' : ''}`}
                  type="button"
                  onClick={() => setActiveAccordion(activeAccordion !== item.ID ? item.ID : null)}
                >
                  <span className="flex-grow-1">{item.MainHeading}</span>

                  {/* Edit/Delete buttons - DIRECT canEdit check */}
                  {canEdit && (
                    <div className="ms-auto me-2" onClick={(e) => e.stopPropagation()}>
                      <button
                        className="btn btn-light btn-sm me-2"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditVersion(item.ID);
                        }}
                        title="Edit Software"
                      >
                        <FaEdit />
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteSoftware(item.ID);
                        }}
                        title="Delete Software"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  )}
                </button>
              </h2>
              <div
                className={`accordion-collapse collapse ${activeAccordion === item.ID ? 'show' : ''}`}
              >
                <div className="accordion-body">
                  <div className="row">
                    <div className="col-lg-7">
                      <DownloadTable
                        data={item.Versions}
                        onEdit={handleEditVersion}
                        onDelete={handleDeleteSetupGuide}
                        canEdit={canEdit}
                      />
                    </div>
                    <div className="col-lg-5">
                      <div className="setup-guide-container">
                        <h5>Setup Guide</h5>
                        {editingContent === item.ID ? (
                          <div>
                            <JoditEditor
                              value={editorContent}
                              onChange={newContent => setEditorContent(newContent)}
                            />
                            <div className="mt-2">
                              <button
                                className="btn btn-success btn-sm me-2"
                                onClick={() => handleSave(item.ID, item.SetupGuideId)}
                              >
                                <FaSave /> Save
                              </button>
                              <button
                                className="btn btn-secondary btn-sm"
                                onClick={() => setEditingContent(null)}
                              >
                                <FaTimes /> Cancel
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div dangerouslySetInnerHTML={{ __html: item.SetupGuide }} />
                            
                            {/* Edit/Delete buttons for Setup Guide - DIRECT canEdit check */}
                            {canEdit && (
                              <div className="mt-3">
                                <button
                                  className="btn btn-outline-primary btn-sm me-2"
                                  onClick={() => handleEditSetupGuide(item.SetupGuide, item.ID)}
                                >
                                  <FaEdit /> Edit
                                </button>
                                {item.SetupGuideId && (
                                  <button
                                    className="btn btn-outline-danger btn-sm"
                                    onClick={() => handleDeleteSetupGuide(item.SetupGuideId)}
                                  >
                                    <FaTrash /> Delete
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SoftwareDownloads;